/**
 * Минимальный набор линейных иконок в стиле SF Symbols / Lucide.
 * Никаких эмодзи: для премиум-UI используем стабильные тонкие иконки.
 * Все иконки наследуют currentColor и единый stroke-width.
 */

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  viewBox: '0 0 24 24',
  'aria-hidden': true,
};

export function BfIconSparkle(p) {
  return (
    <svg {...base} {...p}>
      <path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z" />
      <path d="M19 14l.7 1.9L22 17l-2.3.7L19 20l-.7-2.3L16 17l2.3-1.1L19 14z" />
    </svg>
  );
}
export function BfIconClose(p) {
  return (
    <svg {...base} {...p}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
export function BfIconSearch(p) {
  return (
    <svg {...base} {...p}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}
export function BfIconChat(p) {
  return (
    <svg {...base} {...p}>
      <path d="M21 12.5c0 4.1-4 7.5-9 7.5a10.7 10.7 0 0 1-4-.8L3 21l1.6-4A7.4 7.4 0 0 1 3 12.5C3 8.4 7 5 12 5s9 3.4 9 7.5z" />
    </svg>
  );
}
/** Новый чат — пузырь с «+» (не голый плюс). */
export function BfIconNewChat(p) {
  return (
    <svg {...base} {...p}>
      <path d="M7 5h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-3.5 2.5V7a2 2 0 0 1 2-2z" />
      <path d="M12 8.5v3.5" />
      <path d="M10.25 10.25h3.5" />
    </svg>
  );
}
export function BfIconBookmark(p) {
  return (
    <svg {...base} {...p}>
      <path d="M6 4h12v17l-6-4-6 4V4z" />
    </svg>
  );
}
export function BfIconMenu(p) {
  return (
    <svg {...base} {...p}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}
export function BfIconChevDown(p) {
  return (
    <svg {...base} {...p}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}
export function BfIconChevRight(p) {
  return (
    <svg {...base} {...p}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}
export function BfIconChevLeft(p) {
  return (
    <svg {...base} {...p}>
      <path d="m15 6-6 6 6 6" />
    </svg>
  );
}
export function BfIconMore(p) {
  return (
    <svg {...base} {...p}>
      <circle cx="6" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="18" cy="12" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  );
}
export function BfIconClock(p) {
  return (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </svg>
  );
}
export function BfIconSettings(p) {
  return (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6 1.65 1.65 0 0 0 10 3.09V3a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}
export function BfIconCompass(p) {
  return (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="m15 9-3 6-3-1 1-3 5-2z" />
    </svg>
  );
}
export function BfIconBulb(p) {
  return (
    <svg {...base} {...p}>
      <path d="M9 18h6M10 21h4" />
      <path d="M12 3a6 6 0 0 0-4 10.5c.9.9 1.5 1.6 1.5 2.5v.5h5v-.5c0-.9.6-1.6 1.5-2.5A6 6 0 0 0 12 3z" />
    </svg>
  );
}
export function BfIconShare(p) {
  return (
    <svg {...base} {...p}>
      <path d="M12 16V4M8 8l4-4 4 4M5 12v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
    </svg>
  );
}
export function BfIconBookOpen(p) {
  return (
    <svg {...base} {...p}>
      <path d="M3 5h6a3 3 0 0 1 3 3v12a3 3 0 0 0-3-3H3V5z" />
      <path d="M21 5h-6a3 3 0 0 0-3 3v12a3 3 0 0 1 3-3h6V5z" />
    </svg>
  );
}
export function BfIconLink(p) {
  return (
    <svg {...base} {...p}>
      <path d="M10 14a4 4 0 0 1 0-5.7l3-3a4 4 0 1 1 5.7 5.7l-1.5 1.5" />
      <path d="M14 10a4 4 0 0 1 0 5.7l-3 3a4 4 0 1 1-5.7-5.7l1.5-1.5" />
    </svg>
  );
}
export function BfIconImage(p) {
  return (
    <svg {...base} {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" />
      <path d="m21 16-5-5-9 8" />
    </svg>
  );
}
